export function mapFromAnnouncementsDataToList(announcementsData) {
    // Check if announcementsData or announcementsData.B is undefined
    if (!announcementsData || !announcementsData.B) {
        // Return an empty array or handle the case as appropriate
        return [];
    }
    
    const announcementsList = announcementsData.B;
    return announcementsList.map((announcement) => {
        return {
            timestamp: announcement.TS,
            formattedTime: announcement.TT, // Noticed a typo here and corrected it from formatedTime to formattedTime
            message: announcement.M
        };
    });
}
